import { render, staticRenderFns } from "./FactsheetLaadpunt.vue?vue&type=template&id=87fea53e&"
import script from "./FactsheetLaadpunt.vue?vue&type=script&lang=js&"
export * from "./FactsheetLaadpunt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports